export default __webpack_public_path__ + "static/fall5-a9076b5f89851aacbea83c6402a74b91.webp";